/* eslint-disable quotes */
/** On peut décomposer les routes par module**/
import Layout from "@/layout";

const RegistrationRoutes = {
  path: "/registrations",
  component: Layout,
  redirect: "/registrations/index",
  name: "Registration",
  // alwaysShow: true,
  meta: {
    title: "registrations",
    icon: "el-icon-tickets",
    permissions: ["manage registration"],
  },
  children: [
    {
      path: "registrations",
      component: () =>
        import(/* webpackChunkName: "registrations" */ "@/views/registrations/index"),
      name: "registrations",
      meta: { title: "registrations", icon: "form" },
    },
  ],
};

export default RegistrationRoutes;
